module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-Bold-ea95b4dbc29f422308265c363630a56b.woff2";